<template>
    <div class="content-page">
        <div class="bd">
            <div class="tab-header">
                <el-button type="primary" size="small" @click="addRegion">新建桌位区域</el-button>
            </div>
            <div class="tab-content">
                <div class="list">
                    <el-table :data="regionList" style="width: 100%;">
                        <el-table-column label="桌位区域">
                            <template slot-scope="scope">
                                <div class="tag-name">{{scope.row.areaName}}</div>
                            </template>
                        </el-table-column>
                        <el-table-column label="操作" header-align="right">
                            <template slot-scope="scope">
                                <div class="float-right">
                                    <el-button
                                        size="small"
                                        type="primary"
                                        @click="edit(scope.$index)"
                                        plain
                                    >编辑</el-button>
                                    <el-button
                                        size="small"
                                        plain
                                        @click="delTableArea(scope.row.shopAreaId)"
                                    >删除</el-button>
                                </div>
                            </template>
                        </el-table-column>
                    </el-table>
                    <el-pagination
                        @current-change="handleCurrentChange"
                        :page-size="pageSize"
                        :current-page="pageNo"
                        background
                        layout="prev, pager, next, jumper"
                        :total="pageCount"
                    ></el-pagination>
                </div>
            </div>
        </div>
        <el-dialog
            :visible.sync="dialogAddRegionVisible"
            :close-on-click-modal="false"
            :close-on-press-escape="false"
            width="510px"
        >
            <div slot="title" class="dialog-title">{{addRegionForm.shopAreaId ? '编辑桌位区域':'新建桌位区域'}}</div>
            <el-form
                :model="addRegionForm"
                :rules="addRegionFormRule"
                ref="addRegionForm"
                label-width="68px"
                class="demo-ruleForm"
                :hide-required-asterisk="true"
            >
                <el-form-item label="区域名称" prop="tableConfigName">
                    <el-input
                        v-model="addRegionForm.areaName"
                        :maxlength="15"
                        placeholder="请填写桌位区域（如一楼，大厅）"
                    ></el-input>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button
                    type="primary"
                    @click="createRegion"
                    :loading="isSubmit"
                >{{addRegionForm.shopAreaId ? '立即编辑':'立即创建'}}</el-button>
                <el-button @click="dialogAddRegionVisible = false">取 消</el-button>
            </div>
        </el-dialog>
    </div>
</template>

<script>
import { getShopAreas,getShopAreasNum, addTableArea, delTableArea } from "@/api";
export default {
    data() {
        return {
            regionList: [],
            pageNo: 1,
            pageSize: 5,
            pageCount: 0,
            dialogAddRegionVisible: false,
            addRegionForm: {
                areaName: "",
                shopAreaId: ""
            },
            addRegionFormRule: {
                areaName: [
                    {
                        required: true,
                        message: "请填写区域名称",
                        trigger: "blur"
                    }
                ]
            },
            isSubmit: false
        };
    },
    mounted() {
        this.getPageData();
    },
    methods: {
        getPageData() {
            this.getShopAreas();
            this.getShopAreasNum();
        },
        getShopAreas() {
            getShopAreas({
                pageNo: this.pageNo,
                row: this.pageSize
            }).then(res => {
                if (res.code == 1) {
                    this.regionList = res.data;
                } else {
                    this.regionList = [];
                }
            });
        },
        getShopAreasNum() {
            getShopAreasNum({}).then(res => {
                if (res.code == 1) {
                    this.pageCount = res.data;
                    if (this.pageNo > this.pageCount / this.pageSize) {
                        this.pageNo = Math.ceil(this.pageCount / this.pageSize);
                        this.getShopAreas();
                    }
                }
            });
        },
        addTableArea(params) {
            this.isSubmit = true;
            addTableArea(params).then(res => {
                if (res.code == 1) {
                    this.$notify({
                        title: "提示",
                        message: params.shopAreaId ? "编辑成功" : "新增成功",
                        type: "success",
                        duration: 2000
                    });
                    this.getPageData();
                    this.dialogAddRegionVisible = false;
                } else {
                    this.$notify({
                        title: "提示",
                        message: res.msg,
                        type: "error",
                        duration: 2000
                    });
                }
                setTimeout(() => {
                    this.isSubmit = false;
                }, 500);
            });
        },
        addRegion() {
            this.addRegionForm = {
                areaName: "",
                shopAreaId: ""
            };
            this.dialogAddRegionVisible = true;
        },
        delTableArea(id) {
            this.$msgbox({
                title: "消息",
                message: `是否删除，删除后将无法恢复！`,
                showCancelButton: true,
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                beforeClose: (action, instance, done) => {
                    if (action === "confirm") {
                        delTableArea({
                            shopAreaId: id
                        }).then(res => {
                            if (res.code == 1) {
                                this.$notify({
                                    title: "提示",
                                    message: "删除成功",
                                    type: "success",
                                    duration: 2000
                                });
                                this.getPageData();
                            } else {
                                this.$notify({
                                    title: "提示",
                                    message: res.msg,
                                    type: "error",
                                    duration: 2000
                                });
                            }
                        });
                        done();
                    } else {
                        done();
                    }
                }
            }).then(action => {});
        },
        createRegion() {
            this.$refs.addRegionForm.validate(valid => {
                if (valid) {
                    let params = JSON.parse(JSON.stringify(this.addRegionForm));
                    this.addTableArea(params);
                } else {
                    this.$notify({
                        title: "提示",
                        message: "请完善提交内容",
                        type: "error",
                        duration: 2000
                    });
                    return false;
                }
            });
        },
        handleCurrentChange(val) {
            this.pageNo = val;
            this.getShopAreas();
        },
        edit(index) {
            this.addRegionForm = JSON.parse(
                JSON.stringify(this.regionList[index])
            );
            this.dialogAddRegionVisible = true;
        }
    }
};
</script>

<style lang="less" scoped>
.content-page {
    .tab-content {
        display: block;
        padding: 0 20px;
    }
}
</style>
